import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  constructor() { }

  getSelectedPortfolioId(): string {
    return localStorage.getItem("windlog_selected_portfolio_id");
  }

  setSelectedPortfolioId(selectedPortfolioId) {
    localStorage.setItem("windlog_selected_portfolio_id", selectedPortfolioId);
  }

  getLastSelectedTClassFilter(): string[] {
    let res = localStorage.getItem('t_class_filter')
    if (res) {
      return res.split(';')
    }
    return null;
  }

  setLastSelectedTClassFilter(tclasses: string[]) {
    localStorage.setItem("t_class_filter", tclasses.join(';'));
  }

  setPredictiveModuleFilter(predictiveFilter: string) {
    localStorage.setItem('windlog_predictive_module_filter', predictiveFilter);
  }

  getPredictiveModuleFilter() {
    return localStorage.getItem('windlog_predictive_module_filter');
  }

  getBudgetOptions(): string {
    return localStorage.getItem('budgetOptions');
  }

  setBudgetOptions(options:string) {
    localStorage.setItem('budgetOptions', options);
  }

  clearLocalStorage() {
    localStorage.removeItem('windlog_predictive_module_filter');
  }

  getKpiPortfolioTableColumn(tableId: string): string {
    return localStorage.getItem('kpi_table_columns_'+tableId);
  }

  setKpiPortfolioTableColumn(tableId: string, options:string) {
    localStorage.setItem('kpi_table_columns_'+tableId, options);
  }

  getRevenueDailyGranularity(): string {
    return localStorage.getItem('revenues_daily_granularity');
  }

  setRevenueDailyGranularity(granularity: string) {
    localStorage.setItem('revenues_daily_granularity', granularity);
  }

  getRevenueProductionViewOption(): number {
    let result = +localStorage.getItem('revenues_production_view_option');
    return Number.isNaN(result) ? 0 : result;
  }

  setRevenueProductionViewOption(option: number) {
    localStorage.setItem('revenues_production_view_option', option.toString());
  }
}
